// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lengend[data-v-1b7eb44a] {\n  position: absolute;\n  color: #fff;\n  right: calc(28% - 0.05208rem);\n  z-index: 1;\n  top: 45%;\n  padding: 2px;\n  font-size: 0.08rem;\n}\n", ""]);
// Exports
module.exports = exports;
